import { DataService, ApiService, UserService } from "../service"

export class ProdHtService{

    static async getHtUserToken() {
        const res = await DataService.get(`${ApiService.EngineerApi}/user/getHtUserToken`);
        return res.data;
    }
  
    /**
     * 华天获取sw转中间格式的信息
     * @param prodId 
     * @param skuId 
     * @param Htoken 
     * @param fileName 
     * @param skuName 
     * @returns 
     */
    static async download(StepFileServerPath: string,fileName:string,skuName:string) {
        const Htoken = await this.getHtUserToken();
        const res = await DataService.get(`${ApiService.JrzzApi}/${StepFileServerPath}?Htoken=${Htoken}&fileName=${fileName}&skuName=${skuName}`);
        res.Htoken = Htoken;
        return res;
    }

    static async filedownload(fileName:string,dataId:string) {
        const Htoken = await this.getHtUserToken();
        const res = await DataService.get(`${ApiService.JrzzApi}/prodHt/file/265/download?Htoken=${Htoken}&fileName=${fileName}&dataId=${dataId}`);
        res.Htoken = Htoken;
        return res;
    }

}